// Lightweight Ticker entity wrapper with PascalCase fields only
export default class Ticker {
  constructor(data) {
    // Expect data to have PascalCase fields (Id, Code, Name, Currency, CollectCandles, Tags, Active, Source)
    this.Id = data.Id;
    this.Code = data.Code;
    this.Name = data.Name;
    this.Currency = data.Currency;
    this.CollectCandles = data.CollectCandles;
    this.Tags = data.Tags;
    this.Active = data.Active;
    this.Source = data.Source;
    // static detail ids (may be absent)
    this.Type = data.Type;
    this.CountryId = data.CountryId;
    this.SectorId = data.SectorId;
    this.IndustryId = data.IndustryId;
    this.ExchangeId = data.ExchangeId;
    this.MainTicker = data.MainTicker;
  }
}
